import { defineMessages } from "react-intl";

const messages = defineMessages({
  cardTitle: {
    id: "dashboard.cards.activitiesOverdue.title",
    defaultMessage: "Activities Overdue",
    description: "Title of the Activities Overdue card",
  },
  modalTitle: {
    id: "dashboard.editModal.activitiesOverdue.title",
    defaultMessage: "Edit “Activities Overdue”",
    description: "Title of the Edit Activities Overdue modal",
  },
  orgGoal: {
    id: "dashboard.editModal.activitiesOverdue.goal.org",
    defaultMessage:
      "Activities that are overdue, are <b>assigned to any user</b>, and meet the above criteria will count toward the max amount.",
    description: "Goal description for org level of the Edit Activities Overdue modal",
  },
  teamGoal: {
    id: "dashboard.editModal.activitiesOverdue.goal.team",
    defaultMessage:
      "Activities that are overdue, are <b>assigned to any user in this team</b>, and meet the above criteria will count toward the max amount.",
    description: "Goal description for team level of the Edit Activities Overdue modal",
  },
  user: {
    id: "dashboard.editModal.activitiesOverdue.goal.user.placeholder",
    defaultMessage: "user",
    description: "Placeholder used for Goal description for user level when user is not found",
  },
  userGoal: {
    id: "dashboard.editModal.activitiesOverdue.goal.user",
    defaultMessage:
      "Activities that are overdue, are <b>assigned to {user}</b>, and meet the above criteria will count toward the max amount.",
    description: "Goal description for user level of the Edit Activities Overdue modal",
  },
});

export default messages;
